import { useTranslation } from "react-i18next";

export default function InterneLinks() {
  const { t } = useTranslation("velux-reparatie");
  const cards = t("interneLinks.cards", { returnObjects: true }) as Array<{
    title: string;
    url: string;
    text: string;
  }>;

  return (
    <section className="bg-brand-cream py-16 md:py-24 w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight text-center mb-10 md:mb-14">
          {t("interneLinks.h2")}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.map((card, i) => (
            <a
              key={i}
              href={card.url}
              className="group block bg-white border border-brand-border rounded-2xl p-6 md:p-8 hover:border-brand-yellow transition-colors"
            >
              <h3 className="font-geist font-bold text-lg text-brand-text mb-2 group-hover:text-brand-blue transition-colors">
                {card.title}
              </h3>
              <p className="font-geist text-sm text-brand-text/70 leading-relaxed">
                {card.text}
              </p>
              <div className="mt-4 flex items-center gap-1 text-brand-blue font-geist text-sm font-semibold">
                <span>Meer info</span>
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}